import { useEffect, useState } from "react";
import TextInput from "../components/basicComponents/text-input";
import TextArea from "../components/basicComponents/text-area";
import ImageUpload from "../components/basicComponents/image-upload";
import Container from "../components/basicComponents/container";
import * as Icons from "../assets/SVGs/index";
import { useDispatch, useSelector } from "react-redux";
import Button from "../components/basicComponents/button";
import ColorPicker from "../components/basicComponents/color-picker";

import {
  getSlider,
  addSlider,
  removeSlider,
  editSlider,
  getSlidertById,
} from "../state-management/actions/slider-actions";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import Grid from "../components/grid";
import { setRowStatus } from "../state-management/actions/global-state-actions";
import ToggleSwitch from "../components/basicComponents/switch-box";
import { selectGlobalState } from "../state-management/selectors";
import { SlidersProps } from "../types/public";

export default function SliderManagement() {
  const dispatch = useDispatch();
  const { currentUserData } = useSelector(selectGlobalState);
  const initialData: SlidersProps = {
    title: "",
    link: "",
    description: "",
    priority: "",
    created_by: currentUserData._id,
    picture: null,
    is_active: false,
    color_primary: "#000000",
    color_secondary: "#000000",
  };
  const [slidersData, setSlidersData] = useState<any[]>([]);
  const { rowStatus } = useSelector((state: any) => state.globalState);
  const [formData, setFormData] = useState<SlidersProps>(initialData);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getSlider()(dispatch);
      setSlidersData(response.data);
    };
    fetchData();
    dispatch(setRowStatus("clear id", false));
  }, [dispatch]);

  const handleChange = (e: any) => {
    if (e instanceof File || e === null) {
      setFormData({ ...formData, picture: e });
    } else {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async () => {
    console.log(formData);
    try {
      const response = await addSlider(formData)(dispatch);
      if (response.data) {
        setSlidersData((prev) => [
          ...prev,
          { _id: response.data.NewItem._id, ...formData },
        ]);
        setFormData(initialData);
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext(" اسلایدر مربوطه اضافه شد"));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = async () => {
    try {
      const { _id, ...cleanData } = formData;
      const response = await editSlider(_id, cleanData)(dispatch);
      dispatch(setRowStatus("clear id", false));
      if (response.data) {
        setSlidersData((prev: any) =>
          prev.map((item: any) => (item._id === _id ? formData : item))
        );
        setFormData(initialData);
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext(" اسلایدر مربوطه ویرایش شد"));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSetData = async (clear: boolean, id: string) => {
    try {
      const inputData = slidersData.find((item) => item._id === id);
      const response = await getSlidertById(id)(dispatch);
      setFormData({ ...inputData, content: response.data.content });
    } catch (error) {
      console.log(error);
    }
    if (clear) {
      setFormData(initialData);
    }
  };

  const handleDelete = async (id: string) => {
    console.log("delete");
    try {
      const response = await removeSlider(id)(dispatch);
      if (response) {
        setSlidersData((item) => item.filter((item: any) => item._id !== id));
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("حذف با موفقیت صورت پذیرفت"));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    { headerName: "عنوان اسلاید", field: "title" },
    { headerName: "لینک ", field: "link" },
    { headerName: "اولویت", field: "priority" },
    { headerName: "انتشار", field: "is_active" },
    {
      headerName: "رنگ اول",
      field: "color_primary",
      cellRenderer: (params: any) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingRight: "20px",
            paddingLeft: "20px",
            height: "32px",
            backgroundColor: params.value || "transparent",
            color: params.value !== "#FFFFFF" ? "#ffffff" : "#000000",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      headerName: "رنگ دوم",
      field: "color_secondary",
      cellRenderer: (params: any) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingRight: "20px",
            paddingLeft: "20px",
            height: "32px",
            backgroundColor: params.value || "transparent",
            color: params.value !== "#FFFFFF" ? "#FFFFFF" : "#000000",
          }}
        >
          {params.value}
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col items-center w-full">
      <Container header="اطلاعات مربوط به اسلایدر صفحه اصلی ">
        <div className="w-full">
          <div className="flex md:flex-row flex-col gap-2">
            <div className="mb-5 mt-5 md:w-[33.3%] w-full">
              <TextInput
                name="title"
                value={formData.title}
                placeholder=" عنوان اسلایدر"
                label=" عنوان اسلایدر"
                RightIcon={<Icons.TitleIcon className="w-5 h-5" />}
                onChange={handleChange}
              />
            </div>
            <div className="mb-5 mt-5 md:w-[33.3%] w-full">
              <TextInput
                name="link"
                value={formData.link}
                placeholder=" لینک موردنظر"
                label=" لینک موردنظر"
                RightIcon={<Icons.LinkIcon className="w-5 h-5" />}
                onChange={handleChange}
              />
            </div>
            <div className="mb-5 mt-5 md:w-[33.3%] w-full">
              <TextInput
                name="priority"
                value={formData.priority}
                placeholder=" اولویت نمایش اسلایدر"
                label=" اولویت نمایش اسلایدر"
                RightIcon={<Icons.SliderIcon className="w-5 h-5" />}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="flex md:flex-row flex-col justify-between">
            <div className="mb-5 md:w-[69.5%] w-full">
              <TextArea
                name="description"
                placeholder="توضیحات"
                rows={8}
                value={formData.description}
                onChange={handleChange}
              />
            </div>
            <div className="md:w-[29.5%] w-full h-full">
              <ImageUpload
                onImageChange={(file) => {
                  if (file) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                      const base64String = reader.result as string;
                      setFormData((prev: any) => ({
                        ...prev,
                        picture: base64String,
                      }));
                      localStorage.setItem("sliderImageBase64", base64String);
                    };
                    reader.readAsDataURL(file);
                  } else {
                    setFormData((prev) => ({
                      ...prev,
                      picture: undefined,
                    }));
                    localStorage.removeItem("sliderImageBase64");
                  }
                }}
                storageKey="sliderImageBase64"
                label="آپلود آیکون"
                defaultImage={
                  typeof formData.picture === "string"
                    ? formData.picture
                    : undefined
                }
              />
            </div>
          </div>
          <div className="flex justify-start">
            <div className="md:w-[15%] w-full h-full flex flex-col">
              <ColorPicker
                color={formData.color_primary || "#000000"}
                setColor={(color: string) => {
                  setFormData((prev) => ({
                    ...prev,
                    color_primary: color,
                  }));
                }}
                label="انتخاب رنگ اول"
              />
            </div>
            <div className="md:w-[15%] w-full h-full flex flex-col">
              <ColorPicker
                color={formData.color_secondary || "#000000"}
                setColor={(color: string) => {
                  setFormData((prev) => ({
                    ...prev,
                    color_secondary: color,
                  }));
                }}
                label="انتخاب رنگ دوم"
              />
            </div>
            <div
              className="p-4 flex justify-center items-center"
              style={{ marginLeft: "30px" }}
            >
              <ToggleSwitch
                label="  انتشار"
                checked={formData.is_active}
                onChange={() =>
                  setFormData((prev) => ({
                    ...prev,
                    is_active: !prev.is_active,
                  }))
                }
              />
            </div>
          </div>

          <div className="w-full h-full flex justify-end">
            <Button
              variant={!rowStatus.status ? "success" : "edit"}
              title={!rowStatus.status ? "ثبت" : "ثبت ویرایش"}
              paddingx="20px"
              paddingy="6px"
              onClick={!rowStatus.status ? handleSubmit : handleEdit}
            />
          </div>
        </div>
      </Container>
      <Container header="جدول اسلایدر ها">
        <Grid
          height={700}
          columns={columns}
          userData={slidersData}
          pageSize={10}
          pagination={true}
          editBtn={true}
          deleteBtn={true}
          editable={false}
          btnHeader="تنظیمات"
          handleDelete={handleDelete}
          handleSetData={handleSetData}
        />
      </Container>
    </div>
  );
}
